// extracted by mini-css-extract-plugin
module.exports = {"confirm-email__heading":"ConfirmEmail_confirm-email__heading__U5BSR","confirm-email__summary":"ConfirmEmail_confirm-email__summary__UbvVD"};